export const injectScriptString = (
  scriptString: string,
  target: "head" | "body"
) => {
  if (!scriptString) return;

  const parser = new DOMParser();
  const doc = parser.parseFromString(scriptString, "text/html");
  const scripts = doc.querySelectorAll("script");

  scripts.forEach((oldScript, index) => {
    const newScript = document.createElement("script");

    // Prevent duplicate scripts
    const scriptId =
      oldScript.getAttribute("id") || `global-script-${target}-${index}`;

    if (document.getElementById(scriptId)) return;

    newScript.id = scriptId;

    // Copy all attributes (src, async, defer, etc.)
    Array.from(oldScript.attributes).forEach((attr) => {
      newScript.setAttribute(attr.name, attr.value);
    });

    // Inline script content
    if (oldScript.innerHTML.trim()) {
      newScript.text = oldScript.innerHTML;
    }

    document[target].appendChild(newScript);
  });
};
